import OneliveFooterContent from './OneliveFooterContent';

interface Props {
  onNavigate?: () => void;
}

export default function OneliveMobileDrawerFooter({ onNavigate }: Props) {
  return (
    <div className="onelive-mobile-drawer-footer">
      <OneliveFooterContent onNavigate={onNavigate} variant="drawer" />
    </div>
  );
}
